module.exports = __webpack_public_path__ + "static/media/redo-alt.d465ce7a.svg";